<template>
  <div
    @click="$emit('select')"
    class="p-4 border rounded-md flex items-center flex-nowrap cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800 dark:border dark:border-gray-700"
  >
    <Check :checked="selectedId === id" class="flex-shrink-0" />
    <div class="flex-grow ps-2">
      <p class="font-medium">{{ name }}</p>
      <p class="text-xs text-gray-500">{{ note }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: { type: Number, default: null },
    note: { type: String, default: null },
    name: { type: String, default: null },
    selectedId: { type: Number, default: null },
  },
};
</script>
